import { defineMessages } from 'react-intl';

export default defineMessages({
  score: 'SCORE',
  find: 'FIND SCORE',
  grade: 'RATING',
  nps: 'NPS',

  noMatchingData: 'Ooops, no data here. Try a different time period!',
  noMatchingDataReport: 'Ooops, no data here.',

  bar: 'Bar Chart',
  pie: 'Pie Chart',
  line: 'Line Chart',
  area: 'Area Chart',
  stacked: 'Stacked Bar Chart',
  scatter: 'Scatter Chart',
  compare: 'Cross tabulation',
  table: 'View raw data',
  widget: 'Widget',
  option: 'Option',

  switchAxis: 'Switch axis',
  sort: 'Sort',
  displayModePercentage: 'Percentage of responses',
  displayModeValue: 'Number of responses',
  displayModeScore: 'Calculated score',
  displayModeAverageScore: 'Average score',
  displayModeAllScores: 'All scores',
  displayGradingScale: 'Show grading scale explanation',
  saveReport: 'Add to report',
  saveAsImage: 'Save as image',
  downloadAsExcel: 'Download as Excel',

  showAll: 'Show all',
  invert: 'Toggle all',

  'npsOptionValue_-100': 'Detractors',
  npsOptionValue_0: 'Passive',
  npsOptionValue_100: 'Promoters',

  exit: 'Exit',
  other: 'Other',
  pageviews: 'Pageviews',
  visits: 'Visits',
  respondents: 'Respondents',
  incoming: 'Incoming',
  outgoing: 'Outgoing',
  from: 'From',
  to: 'To',
  prev: 'Previous',
  next: 'Next',
  category: 'Category',

  xAxisMarker: 'X-Axis marker',
  yAxisMarker: 'Y-Axis marker',
  showLabels: 'Show labels',

  scaleNotApproved: 'Not approved',
  scaleApproved: 'Approved',
  scaleGood: 'Good',
  scaleVeryGood: 'Very good',

  findScaleNotApproved: 'Lower than 50',
  findScaleApproved: '50 - 59',
  findScaleGood: '60 - 69',
  findScaleVeryGood: '70 or higher',

  gradeScaleNotApproved: 'Lower than 3.50',
  gradeScaleApproved: '3.50 - 3.99',
  gradeScaleGood: '4.00 - 4.19',
  gradeScaleVeryGood: '4.20 or higher',

  npsScaleNotApproved: 'Lower than 0',
  npsScaleApproved: '0 - 29',
  npsScaleGood: '30 - 49',
  npsScaleVeryGood: '50 or higher',

  // CSI labels
  csiOptionValue_1: 'Very dissatisfied',
  csiOptionValue_2: 'Dissatisfied',
  csiOptionValue_3: 'Neither',
  csiOptionValue_4: 'Satisfied',
  csiOptionValue_5: 'Very satisfied',

  // ZIP labels
  unknown: 'Unknown',
  city: 'City',
  largeTowns: 'Large towns',
  elsewhereInCountry: 'Elsewhere in country',

  responseCount: '{count} responses',
  surveyCount: '{count} surveys',
  viewCount: '{count} views',

  addComment: 'Add comment',
  clickToCreateSegment: 'Click to a create segment for this result',
  gradingScale: 'Grading scale',
});
